import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=c261f4a8&scoped=true&"
import script from "./rules.vue?vue&type=script&lang=ts&"
export * from "./rules.vue?vue&type=script&lang=ts&"
import style0 from "./rules.vue?vue&type=style&index=0&id=c261f4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c261f4a8",
  null
  
)

export default component.exports